import '../stylesheets/landing_page.scss'

(function($) {
    $(document).on('change', '.js-Check-step-address', function() {
      var $jsNextBtn = $(this).parents(".lpFormAnswer").find(".js-nextBtn");
      if ($("#entry_prefecture_id").val() === "" || $("#entry_city").val() === "") {
        $jsNextBtn.addClass("btn-disabled");
      }else{
        $jsNextBtn.removeClass("btn-disabled");
      }
    });

    $(document).on('change', '.js-Check-step-name', function() {
      var $jsNextBtn = $(this).parents(".lpFormAnswer").find(".js-nextBtn");
      var $entryLastName = $("#entry_last_name").val();
      var $entryFirstName = $("#entry_first_name").val();
      var $year = $("#year").val();
      var $sex = $(".sex-Check").filter(':checked').val();
      if ($entryLastName === "" || $entryFirstName === "" || $year === "" || !$sex) {
        $jsNextBtn.addClass("btn-disabled");
      }else{
        $jsNextBtn.removeClass("btn-disabled");
      }
    });

    $(document).on('change', '.js-Check-step1-in-ranch', function() {
      if (!$(".status-Check").filter(':checked').val() || !$(".career-Check").filter(':checked').val() || !$(".license-Check").filter(':checked').val()) {
        $(this).parents(".lpFormAnswer").find(".js-nextBtn").addClass("btn-disabled");
      }else{
        $(this).parents(".lpFormAnswer").find(".js-nextBtn").removeClass("btn-disabled");
      }
    });

    $(document).on('change', '.js-Check-step2-in-ranch', function() {
      var $prefectureSelect = $('select[name="entry\\[prefecture_id\\]"]');
      var $citySelect = $('select[name="entry\\[city\\]"]');
      if(!$(".timing-Check").filter(':checked').val() || !$prefectureSelect.val() || !$citySelect.val()) {
        $(this).parents(".lpFormAnswer").find(".js-nextBtn").addClass("btn-disabled");
      }else{
        $(this).parents(".lpFormAnswer").find(".js-nextBtn").removeClass("btn-disabled");
      }
    });

    $(document).on('change', '.js-Check-step3-in-ranch', function() {
      var $jsNextBtn = $(this).parents(".lpFormAnswer").find(".js-nextBtn");
      var entryLastName = $("#entry_last_name").val();
      var entryFirstName = $("#entry_first_name").val();
      var year = $("#year").val();
      var houseMovingChecked = $(".house-moving-Check").filter(':checked').val();
      if (entryLastName === "" || entryFirstName === "" || year === "" || !houseMovingChecked) {
        $jsNextBtn.addClass("btn-disabled");
      }else{
        $jsNextBtn.removeClass("btn-disabled");
      }
    });

    $(document).on('change', '.js-Check-submit', function() {
      var $jsNextBtn = $(this).parents(".lpFormAnswer").find(".js-nextBtn");
      var valid_tel = $("#entry_tel").val().replace(/-/g, '').match(/^[0-9]{10,11}$/);
      var valid_email = $("#entry_email").val().match(/^[a-z0-9+._-]+@([a-z0-9-]+\.)+[a-z]+$/i);
      if (!valid_tel || !valid_email || !$('#entry_agreement')[0].checked) {
        $jsNextBtn.addClass("btn-disabled");
      }else{
        $jsNextBtn.removeClass("btn-disabled");
      }
    });

    var timecheckflag = false;
    $(document).on('change', '.js-Check-time', function() {
      var timecheckedsum = $('.js-Check-time:checked').length;
      var $jsNextBtn = $(this).parents(".lpFormAnswer").find(".js-nextBtn");
      if (timecheckedsum === 0) {
        $jsNextBtn.addClass("btn-disabled");
        timecheckflag = false;
      } else {
        $jsNextBtn.removeClass("btn-disabled");
        timecheckflag = true;
      }
    });

    $(function() {
      $("#js-firstChatMove01")
          .css({opacity: '0.0'})
          .animate({opacity: '1'}, 800);
      setTimeout(function(){
        $("#js-firstChatMove02")
        .css({opacity: '0.0'})
        .animate({opacity: '1'}, 800);
      },1000);
    });

    $(function() {
      var $box = $('#stage');
      var $form = $('form');
      var $navSteps = $('#this-step').find('li[rel]');
      var steps = {};

      $navSteps.each(function (){
        steps[$(this).attr('rel')] = $(this);
      });

        var $prefectureSelect = $box.find('select[name="entry\\[prefecture_id\\]"]');
        var $citySelect = $box.find('select[name="entry\\[city\\]"]');

        $prefectureSelect.on('change', function(e, options){
            options = options || {};

            // prefecture が変わったら
            var prefecture = $(this).val();

            // 選択出来ないようにロック
            $prefectureSelect.add($citySelect).attr('disabled', true);
            // 選択肢を削除
            $citySelect.find('option:not([value=""]), optgroup').remove();

            if (!prefecture) {
                // ロックを解除
                $prefectureSelect.add($citySelect).attr('disabled', false);
                return true;
            }

            $.getJSON('/entries/districts.json?prefecture_id=' + prefecture, function (cities) {
                $.each(cities, function (i, city) {
                    $citySelect.append($('<option/>').val(city.name).text(city.name));
                });
                if (options.id) {
                    $citySelect.val(options.id);
                    $citySelect.trigger('change');
                    $('input[name=address],input[name=address1]').focus();
                }
            }).fail(function () {
                alert('通信に失敗しました');
            }).always(function () {
                // ロックを解除
                $prefectureSelect.add($citySelect).attr('disabled', false);
            });
        });

      if ($form.length !== 1) {
        throw 'フォームの個数が一致しません。';
      }

      // enter keyでのsubmit抑制 最後の提出ボタンが有効になるまで送信しない。
      $form.submit(e => {
        if($(`#submit-btn`).hasClass('btn-disabled')) {
          return false
        }
      })

      // バリデーション
      $.fn.validate = function() {
        function errorMessage($target, message) {
          $target.before($('<div>').text(message).addClass('error-message alert label'));
        }

        function validate($input) {
          $input.removeClass('error');

          if ($input.is('input[type=radio]')) {
            if (!$input.filter(':checked').val()) {
              $input.addClass('error');
              errorMessage($input.parent(), '選択してください');
              return false;
            }

            return true;
          }

          if ($input.is('.js-Check-step-address')) {
            if (!$input.val()) {
              $input.addClass('error');
              errorMessage($input, $input.is('select') ? '選択してください' : '入力してください');
              return false;
            }
            return true;
          }

          if ($input.is('.js-Check-step-name')) {
            if (!$input.val()) {
              $input.addClass('error');
              errorMessage($input, $input.is('select') ? '選択してください' : '入力してください');
              return false;
            }
            return true;
          }

          if ($input.is('.js-Check-step6')) {
            if (!$input.val()) {
              $input.addClass('error');
              errorMessage($input, $input.is('select') ? '選択してください' : '入力してください');
              return false;
            }
            return true;
          }

          if ($input.is('.js-Check-time')) {

            if (!timecheckflag) {
              $input.addClass('error');
              errorMessage($input.parent(), '選択してください');
              return false;
            }

            return true;
          }

          if ($input.length !== 1) {
            throw '不正なフォームです。';
          }

          var method = $input.data('validation');
          if (method === 'tel' && !$input.val().match(/^[0-9]{10,11}$/)) {
            $input.addClass('error');
            errorMessage($input, '半角数字で入力してください');
            return false;
          }

          if (method === 'mail' && !$input.val().match(/^[a-z0-9+._-]+@([a-z0-9-]+\.)+[a-z]+$/i)) {
            $input.addClass('error');
            errorMessage($input, '書式が不正です');
            return false;
          }

          if (method === 'kana' && !$input.val().match(/^[ぁ-んァ-ン・　 ー]+$/)) {
            $input.addClass('error');
            errorMessage($input, 'ひらがなで入力してください');
            return false;
          }

          return true;
        }

        var $target = this;
        var result = true;

        $target.each(function() {
          var $div = $(this);
          $div.find('.error-message').remove();

          $.unique($div.find('input, select, textarea')
            .map(function(){
              return $(this).attr('name');
            }))
            .each(function(index, name) {
              var letters = [/\[/g, /\]/g, /\(/, /\)/];
              var escaped_letters = ['\\[', '\\]', '\\(', '\\)'];
              var escaped_name = name;
              for (var i = 0; i < letters.length; i++) {
                escaped_name = escaped_name.replace(letters[i], escaped_letters[i]);
              }
              var $input = $div.find('[name=' + escaped_name + ']');
              var events = 'click.validate blur.validate change.validate';

              $input.off(events).on(events, function() {
                $target.validate();
              });

              if (!validate($input)) {
                result = false;
              }
            });
        });

        return result;
      };

      function scrollTo($target) {
        function done() {
          $target.data('scrolling', false);
        }

        if ($target.data('scrolling')) {
          return false;
        }

        $target.data('scrolling', true);
        var position = 0;
        if($target.position() && $target.position().top) {
          position = $target.position().top;
        }

        if (position !== 0) {
          $('html,body').animate({scrollTop: position}, 100, done);
        } else {
          done();
        }

        $navSteps.removeClass('current');
        steps[$target.attr('id')] && steps[$target.attr('id')].addClass('current');
      }

      // 次へクリック時
      $box.find('.scroll-to').on('click', function() {
        var $this = $(this);
        var $target = $($this.attr('href'));
        var $displaySlide = $('.active');

        if (!$this.is('.back') && !$this.parents('.step').validate()) {
          return false;
        }
        $displaySlide.animate({"marginLeft":"-100%"},100,"swing", function() {
          $displaySlide.removeClass('active');
          $displaySlide.next().css('margin-left','100%');
          $displaySlide.next().addClass('active');
          $displaySlide.next().animate({"marginLeft":"0%"},100,"swing");
        });

        scrollTo($target);
      });

      // 戻るクリック時
      $box.find('.back').on('click', function() {
        var $this = $(this);
        var $target = $($this.attr('href'));
        var $displaySlide = $('.active');

        $displaySlide.animate({"marginLeft":"100%"},100,"swing", function() {
          $displaySlide.removeClass('active');
          $displaySlide.next().css('margin-left','-100%');
          $displaySlide.prev().addClass('active');
          $displaySlide.prev().animate({"marginLeft":"0%"},100,"swing");
        });

        scrollTo($target);
      });

      $('.js-submitButton').on('click', function(e) {
        e.preventDefault();
        const form = document.querySelector('#contactable_times_form');
        const formData = new FormData(form);
        const options = {
          method: 'POST',
          body: formData,
        }
        const url = form.getAttribute('action');
        fetch(url, options)
          .then(_ => {
            $('.lpForm01').removeClass('active');
            $('.lpForm02').addClass('active');
          })
          .catch(e => {
            console.log(e);
          })
      });
    });
  })(jQuery);
